<template>
  <div>
    <v-card
      elevation="5"
    >
      <v-toolbar
        color="primaryLight"
        dark
        dense
      >
        <v-toolbar-title>Incendio</v-toolbar-title>

        <v-progress-circular
          v-show="updatingEstadoIncendio || updatingNivelIncendio"
          class="ml-4"
          indeterminate
        />

        <v-tooltip
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              fab
              small
              v-bind="attrs"
              color="secondary"
              :disabled="disabledByRol"
              right
              absolute
              :style="{marginRight: '150px'}"
              v-on="on"
              @click="showDialogEditIncendio = true"
            >
              <v-icon
                color="primary"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar incendio</span>
        </v-tooltip>

        <v-tooltip
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              v-show="showAddNiveles"
              fab
              small
              v-bind="attrs"
              color="secondary"
              :disabled="disableAddNivel || disabledByRol"
              right
              absolute
              v-on="on"
              @click="changeVisibilityNivelIncendio"
            >
              <!--:style="{marginRight: '50px'}"-->
              <v-icon
                color="primary"
              >
                mdi-car-brake-fluid-level
              </v-icon>
            </v-btn>
          </template>
          <span
            v-if="disableAddNivel"
          >Es necesario finalizar el anterior nivel</span>
          <span
            v-else
          >Añadir nivel incendio</span>
        </v-tooltip>
        <v-tooltip
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              fab
              small
              v-bind="attrs"
              color="secondary"
              right
              absolute
              :style="{marginRight: '100px'}"
              v-on="on"
              @click="showDialogMediosEstatales = true"
            >
              <v-icon
                color="primary"
              >
                mdi-file-export
              </v-icon>
            </v-btn>
          </template>
          <span>Pedir medios estatales</span>
        </v-tooltip>
        <v-tooltip
          bottom
        >
          <template
            #activator="{ on, attrs }"
          >
            <v-btn
              fab
              small
              v-bind="attrs"
              color="secondary"
              :disabled="disabledByRol"
              right
              absolute
              v-on="on"
              @click="toggleEstadoEspecial()"
              :style="{marginRight: '50px'}"
            >
             <v-icon color="primary">
                {{ estadoEspecialActivo ? 'mdi-undo' : 'mdi-check-circle' }}
              </v-icon>
            </v-btn>
          </template>
          <span>
            {{ estadoEspecialActivo
              ? 'Quitar estado finalizado por responsable de guardia'
              : 'Finalizar por responsable de guardia'
            }}
          </span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <v-data-table
          :items="datosIncendioItems"
          dense
          hide-default-footer
        >
          <template
            #item="props"
          >
            <tr>
              <td>
                <span>{{ props.item.campo }}</span>
              </td>
              <td>
                <v-skeleton-loader
                  v-if="loading"
                  type="text"
                />
                <span
                  v-else
                >{{ props.item.valor }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>

        <v-data-table
          v-if="!loading"
          :headers="headers"
          :items="incendio.ESTADOS"
          hide-default-footer
        >
          <template
            #no-data
          >
            <p>Datos no disponibles.</p>
          </template>

          <template
            #[`item.FECHA`]="{ item }"
          >
            <span>{{ item.FECHA | formatDate }}</span>
          </template>

          <template
            #[`item.ESTADO`]="{ item }"
          >
            <v-chip
              class="chip"
              :color="item.TIPO_INCENDIO_ESTADO.COLOR"
              dark
            >
              {{ item.TIPO_INCENDIO_ESTADO.INCENDIO_ESTADO }}
            </v-chip>
          </template>

          <!-- <template #[`item.ACCIONES`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="showIncendioEstadoEdit(item.TIPO_INCENDIO_ESTADO.VALUE)">
                  <v-icon color="black">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar estado incendio</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <div class="d-inline-block" v-bind="attrs" v-on="on">
                  <v-btn icon :disabled="disableFinalizar" v-if="showAddEstado(item)" @click="setEstadoIncendio(item.TIPO_INCENDIO_ESTADO)">
                    <v-icon color="black">mdi-plus</v-icon>
                  </v-btn>
                </div>
              </template>
              <span v-if="disableFinalizar">Es necesario finalizar las actuaciones de los medios <br>y finalizar el ultimo nivel del incendio</span>
              <span v-else>Añadir estado incendio</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" v-show="showRemoveEstado(item)" @click="handleDeleteEstadoIncendio()">
                  <v-icon color="black">mdi-minus</v-icon>
                </v-btn>
              </template>
              <span>Quitar estado incendio</span>
            </v-tooltip>
          </template> -->
        </v-data-table>

        <v-data-table
          v-show="showNivelesTable"
          :headers="headers2"
          :items="incendio.NIVELES"
          hide-default-footer
        >
          <template
            #[`item.NIVEL`]="{ item }"
          >
            <v-chip
              class="chip"
              :color="item.TIPO_INCENDIO_NIVEL.COLOR"
              dark
            >
              {{ item.TIPO_INCENDIO_NIVEL.INCENDIO_NIVEL }}
            </v-chip>
          </template>
          <template
            #[`item.FECHA_INICIO`]="{ item }"
          >
            <span>{{ fechahora(item.FECHA_INICIO) }}</span>
          </template>
          <template
            #[`item.FECHA_FIN`]="{ item }"
          >
            <span>{{ fechahora(item.FECHA_FIN) }}</span>
          </template>

          <template
            #[`item.ACCIONES`]="{ item, index}"
          >
            <!--<template #[`item.ACCIONES`]="{ item,index}">-->
            <v-tooltip
              bottom
            >
              <template
                #activator="{ on, attrs }"
              >
                <v-btn
                  icon
                  v-bind="attrs"
                  :disabled="disabledByRol"
                  v-on="on"
                  @click="showEditNivelDialog(item,index)"
                >
                  <v-icon
                    color="black"
                  >
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Editar nivel incendio</span>
            </v-tooltip>

            <v-tooltip
              bottom
            >
              <template
                #activator="{ on, attrs }"
              >
                <div
                  class="d-inline-block"
                  v-bind="attrs"
                  v-on="on"
                >
                  <!-- Hack para mostrar tooltip con boton disabled -->
                  <v-btn
                    v-show="showRemoveNivel(item)"
                    icon
                    :disabled="disabledByRol"
                    @click="deleteNivelIncendio()"
                  >
                    <v-icon
                      color="black"
                    >
                      mdi-minus
                    </v-icon>
                  </v-btn>
                </div>
              </template>
              <span>Eliminar el nivel</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <vx-dialog-edit-incendio
      :show="showDialogEditIncendio"
      :incendio="incendio"
      :saving="savingIncendio"
      @aceptar="aceptarEditIncendio"
      @cancelar="showDialogEditIncendio = false"
    />
    <vx-dialog-add-nivel-incendio
      :show="showAddNivelIncendioDialog"
      :id-incendio="idIncendio"
      @aceptar="changeVisibilityNivelIncendio"
      @cancelar="changeVisibilityNivelIncendio"
      @redrawIncendio="redrawIncendio"
    />
    <vx-dialog-edit-nivel-incendio
      :show="showEditNivelIncendioDialog"
      :id-incendio="incendio.ID_INCENDIO"
      :data-nivel="dataNivel"
      @close="showEditNivelIncendioDialog = false"
      @redrawIncendio="redrawIncendio"
    />
    <vx-dialog-edit-incendio-estado
      :show="showDialogEstadoEdit"
      :id-incendio="incendio.ID_INCENDIO"
      :codigo-tipo-estado="codigoTipoEstadoEdit"
      @close="showDialogEstadoEdit = false"
    />
    <vx-dialog-medios-estatales
      :show="showDialogMediosEstatales"
      :emergencia="emergencia"
      :peticion="peticion"
      :id-incendio="incendio.ID_INCENDIO"
      @cancelar="showDialogMediosEstatales = false"
    />
  </div>
</template>

<script>
import DialogAddNivelIncendio from './DialogAddNivelIncendio.vue'
import DialogEditNivelIncendio from './DialogEditNivelIncendio.vue'
import DialogEditIncendio from './DialogEditIncendio'
import DialogEditIncendioEstado from './DialogEditIncendioEstado'
import DialogMediosEstatales from './peticionMediosEstatales/DialogMediosEstatales.vue'

import * as ArcGIS from '../../../helpers/ArcGIS'
import { mapActions, mapGetters } from 'vuex'
import DateService, { FMT } from '@/helpers/DateService'
import { TIPO_INCENDIO_ESTADO } from '@/helpers/constants'

export default {
  components: {
    'vx-dialog-edit-incendio-estado': DialogEditIncendioEstado,
    'vx-dialog-edit-incendio': DialogEditIncendio,
    'vx-dialog-add-nivel-incendio': DialogAddNivelIncendio,
    'vx-dialog-edit-nivel-incendio': DialogEditNivelIncendio,
    'vx-dialog-medios-estatales': DialogMediosEstatales
  },

  props: {
    idIncendio: String,
    loading: Boolean
  },

  data: () => ({
    headers: [
      { text: 'FECHA', value: 'FECHA', align: 'left', sortable: true },
      { text: 'ESTADO', value: 'ESTADO', align: 'center', sortable: false }
      // { text: '', value: 'ACCIONES', align: 'center', width: '25%', sortable: false }
    ],
    headers2: [
      { text: 'FECHA INICIO', value: 'FECHA_INICIO', align: 'left', sortable: true },
      { text: 'FECHA FIN', value: 'FECHA_FIN', align: 'left', sortable: true },
      { text: 'NIVEL', value: 'NIVEL', align: 'center', sortable: false },
      { text: '', value: 'ACCIONES', align: 'center', width: '25%', sortable: false }
    ],

    emergencia: {},
    peticion: {},

    updatingEstadoIncendio: false,
    updatingNivelIncendio: false,
    showAddNivelIncendioDialog: false,
    showEditNivelIncendioDialog: false,
    dataNivel: null,

    showDialogEditIncendio: false,
    savingIncendio: false,

    showDialogEstadoEdit: false,
    showDialogEstadoAdd: false,
    showDialogMediosEstatales: false,

    codigoTipoEstadoEdit: null,
    dateFormat: 'DD/MM/YYYY HH:mm'
  }),

  computed: {

    ...mapGetters('incendio', ['getIncendioByID']),

    incendio() {
      const incendioCopy = structuredClone(this.getIncendioByID(this.idIncendio))
      this.setEmergencia(incendioCopy)
      return incendioCopy || {}
    },

    deteccion() {
      const deteccion = this.incendio ? this.$store.getters['incendio/getTipoDeteccionById'](this.incendio.ID_TIPO_DETECCION) : null
      return deteccion || {}
    },

    datosIncendioItems() {
      return [
        { campo: 'Fecha creación:', valor: this.$date.parseDate(this.incendio.FECHA_CREACION).format('DD/MM/YYYY HH:mm') },
        { campo: 'Municipio:', valor: this.incendio.MUNICIPIO },
        { campo: 'Localidad:', valor: this.incendio.LOCALIDAD },
        { campo: 'Coordenadas:', valor: `${this.incendio.LATITUD}, ${this.incendio.LONGITUD}` },
        { campo: 'Detección:', valor: this.deteccion.DETECCION },
        { campo: 'Observaciones:', valor: this.incendio.OBSERVACIONES }
      ]
    },

    disableFinalizar() {
      return (!this.actuacionesCerradas && this.incendio.ESTADOS[0].TIPO_INCENDIO_ESTADO.VALUE === 3) || (this.showNivelesTable && this.incendio.ESTADOS[0].TIPO_INCENDIO_ESTADO.VALUE === 3)
    },
    showNivelesTable() {
      return this.incendio.NIVELES && this.incendio.NIVELES.length > 0
    },
    showAddNiveles() {
      if (this.incendio.ESTADOS) {
        return this.incendio.ESTADOS[0].TIPO_INCENDIO_ESTADO.VALUE !== 4
      } else return false
    },

    disableAddNivel() {
      return !this.incendio.NIVELES ? false : this.incendio.NIVELES.length > 0 ? this.incendio.NIVELES[0].FECHA_FIN === null : false
    },

    actuacionesCerradas() {
      for (let i = 0; i < this.incendio.SECTORES.length; i++) {
        const sector = this.incendio.SECTORES[i]

        for (let j = 0; j < sector.MEDIOS.length; j++) {
          const medio = sector.MEDIOS[j]

          if (!medio.FECHA_FINALIZADO) {
            return false
          }
        }
      }
      return true
    },
    disabledByRol() {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    },

    estadoEspecialActivo () {
      return !!this.incendio?.ESTADOS?.find(
        estado => estado.TIPO_INCENDIO_ESTADO.VALUE === -1
      )
    }
  },

  watch: {
    idIncendio() {
      this.showEditNivelIncendioDialog = false
      this.dataNivel = null
    },
    incendio: {
      handler(val, oldVal) {
        if ((val && val.ID_INCENDIO) && (oldVal && oldVal.ID_INCENDIO)) {
          const didLatLonChange = val.LATITUD !== oldVal.LATITUD || val.LONGITUD !== oldVal.LONGITUD
          const didEstadosChange = val.ESTADOS.length !== oldVal.ESTADOS.length
          if (didLatLonChange || didEstadosChange) {
            this.redrawIncendio()
          }
        }
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('incendio', ['deleteEstadoIncendio', 'addEstadoIncendio', 'editIncendio']),

    setEmergencia(incendio) {
      this.emergencia = incendio
    },

    showEditNivelDialog(item, index) {
      this.dataNivel = item
      this.dataNivel = { ...this.dataNivel, index }
      this.showEditNivelIncendioDialog = true
    },

    showRemoveNivel(item) {
      return item.ID_INCENDIO_NIVEL === this.incendio.NIVELES[0].ID_INCENDIO_NIVEL
    },

    changeVisibilityNivelIncendio() {
      this.updatingEstadoIncendio = !this.updatingEstadoIncendio
      this.showAddNivelIncendioDialog = !this.showAddNivelIncendioDialog
    },

    showAddEstado(item) {
      const isEstadoMasReciente = item.TIPO_INCENDIO_ESTADO.VALUE === this.incendio.ESTADOS[0].TIPO_INCENDIO_ESTADO.VALUE
      const noIsFinalizado = this.incendio.ESTADOS[0].TIPO_INCENDIO_ESTADO.VALUE !== 4

      // Comprobacion dos estados en el mismo minuto
      const date = new Date(this.incendio.ESTADOS[0].FECHA)
      const dateNow = new Date()

      const isSameMinute = (dateNow.getTime() - date.getTime()) > 60000 // 60000 ms = 1 min
      return isEstadoMasReciente && noIsFinalizado && isSameMinute
    },

    showRemoveEstado(item) {
      const isEstadoMasReciente = item.TIPO_INCENDIO_ESTADO.VALUE === this.incendio.ESTADOS[0].TIPO_INCENDIO_ESTADO.VALUE
      const noIsInicio = this.incendio.ESTADOS[0].TIPO_INCENDIO_ESTADO.VALUE !== 0

      return isEstadoMasReciente && noIsInicio
    },

    async aceptarEditIncendio(incendio) {
      if (this.savingIncendio) return

      this.savingIncendio = true
      try {
        await this.editIncendio(incendio)
        this.showDialogEditIncendio = false
      } catch (e) {
        this.$notify({
          title: 'Editar incendio',
          text: 'No se han podido guardar los datos del incendio',
          type: 'error'
        })
      } finally {
        this.savingIncendio = false
      }
    },

    setEstadoIncendio(estado) {
      if (this.updatingEstadoIncendio) return

      this.updatingEstadoIncendio = true
      const estadosIncendio = this.$store.getters['incendio/tiposIncendioEstado']

      let estadoAdd
      for (let i = 0; i < estadosIncendio.length; i++) {
        if (estado.VALUE === estadosIncendio[i].VALUE) {
          estadoAdd = estadosIncendio[i + 1]
          break
        }
      }

      const estadoIncendio = {
        ID_INCENDIO_ESTADO: this.$uuid.createUUID(),
        ID_INCENDIO: this.idIncendio,
        ID_TIPO_INCENDIO_ESTADO: estadoAdd.ID_TIPO_INCENDIO_ESTADO,
        FECHA: this.$date.now(),
        TIPO_INCENDIO_ESTADO: estadoAdd
      }

      this.$store.dispatch('incendio/addEstadoIncendio', estadoIncendio).then(() => {
      }).catch((e) => {
        this.$notify({
          title: 'Cambio de estado',
          text: `Error al cambiar el estado del incendio a ${estadoAdd.INCENDIO_ESTADO}`,
          type: 'error'
        })
      }).finally(() => {
        this.updatingEstadoIncendio = false
      })
    },

    handleDeleteEstadoIncendio () {
      if (this.updatingEstadoIncendio) return

      this.updatingEstadoIncendio = true

      const data = {
        ID_INCENDIO_ESTADO: this.incendio.ESTADOS[0].ID_INCENDIO_ESTADO,
        ID_INCENDIO: this.incendio.ESTADOS[0].ID_INCENDIO,
        NUEVO_ESTADO: this.incendio.ESTADOS[1].TIPO_INCENDIO_ESTADO.INCENDIO_ESTADO
      }

      this.$store.dispatch('incendio/deleteEstadoIncendio', data)
      setTimeout(() => {
        this.updatingEstadoIncendio = false
      }, 1000)
    },
    deleteNivelIncendio() {
      if (this.updatingNivelIncendio) return

      this.updatingNivelIncendio = true

      const data = {
        ID_INCENDIO_NIVEL: this.incendio.NIVELES[0].ID_INCENDIO_NIVEL,
        ID_INCENDIO: this.incendio.NIVELES[0].ID_INCENDIO
      }

      this.$store.dispatch('incendio/deleteNivelIncendio', data)
      setTimeout(() => {
        this.redrawIncendio()
        this.updatingNivelIncendio = false
      }, 1000)
    },

    showIncendioEstadoEdit(codigo) {
      this.codigoTipoEstadoEdit = codigo
      this.showDialogEstadoEdit = true
    },

    redrawIncendio() {
      ArcGIS.redrawIncendios()
    },

    fechahora(value) {
      if (!value) return
      return DateService.toDayjs(value, FMT.date).format(FMT.date)
    },

    async toggleEstadoEspecial() {
      try {
        this.updatingEstadoIncendio = true
        if (this.estadoEspecialActivo) {
          const ID_INCENDIO_ESTADO = this.incendio?.ESTADOS?.find(
            estado => estado.TIPO_INCENDIO_ESTADO.VALUE === -1
          ).ID_INCENDIO_ESTADO
          const data = { ID_INCENDIO_ESTADO, ID_INCENDIO: this.idIncendio }
          await this.deleteEstadoIncendio(data)
        } else {
          const newState = {
            ID_TIPO_INCENDIO_ESTADO: TIPO_INCENDIO_ESTADO.FINALIZADO_POR_RESPONSABLE_DE_GUARDA,
            ID_INCENDIO: this.idIncendio,
            FECHA: DateService.getCurrentDayJs()
          }
          await this.addEstadoIncendio(newState)
        }
      } catch (error) {
        console.error('Error al cambiar el estado de finalizado por responsable de guardia:', error)
        this.$notify({
          title: 'Error al cambiar el estado',
          text: 'Error al cambiar el estado de finalizado por responsable de guardia',
          type: 'error'
        })
      } finally {
        this.updatingEstadoIncendio = false
      }
    }
  }
}
</script>

<style scoped>
  .chip {
    width: 300px;
  }

  .chip >>> .v-chip__content { /* Centrar texto chips */
    margin: auto !important;
  }
</style>
